import { transformScoreData } from '../../../components/ListingScore/scoreUtils';

// Navigation helpers for listing-score cards, shared by the Manage page's
// merged grid and the listing-score filter view.

export const viewScoreBatch = (navigate, batch) => {
  navigate('/dashboard/listing-score-results', { state: { selectedBatchId: batch.task_id } });
};

export const viewListingScore = (navigate, asin, scoreData) => {
  if (!scoreData || !scoreData.has_score) return;
  navigate('/dashboard/listing-score-detail', {
    state: { selectedScoreData: transformScoreData(asin, scoreData) },
  });
};
